angular.module('impactx.rfx').controller('RFXThreadListBuyerCtrl',
    RFXThreadListBuyerCtrl);

$inject = ["$routeParams", "selectedListItems", "$scope"];

function RFXThreadListBuyerCtrl($routeParams, selectedListItems, $scope)
{
    var ctrl = this;
    ctrl.$onInit = function () {
        ctrl.conversation = $scope.trns.conversation;
        ctrl.unreadConversation = $scope.trns.unreadConversation;
    }

    this.canEditBuyer = function () {
        return selectedListItems.isSingleSelection()
            && selectedListItems.getFirstSelectedItem().isSupport
            && selectedListItems.getFirstSelectedItem().isSupport.value == "0";
    };

    this.canEditSupport = function () {
        return selectedListItems.isSingleSelection() &&
            selectedListItems.getFirstSelectedItem().isSupport
            && selectedListItems.getFirstSelectedItem().isSupport.value == "1";
    };

    this.getEditLinkBuyer = function () {
        return "rfxthread/edit/buyer/" + selectedListItems.getFirstSelectedItem().id + "/" + selectedListItems.getFirstSelectedItem().rfqhid
    };

    this.getEditLinkSupport = function () {
        return "rfxthread/edit/buyer/" + selectedListItems.getFirstSelectedItem().id + "/" + selectedListItems.getFirstSelectedItem().rfqhid + "/true"
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getEditLinkBuyer, type:'link', condition: ctrl.canEditBuyer, process: 'RFXThreadBuyerList'},
        {label: "details", linkFunction: ctrl.getEditLinkSupport, type:'link', condition: ctrl.canEditSupport, process: 'RFXThreadBuyerList'}
    ];

    this.meta = {
        // singleActionsTemplate: 'modules/rfx/templates/rfx-thread-list.singleactions.tmpl.html',
        rowTemplate: 'modules/rfx/templates/rfx-thread-list.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/thread/list/buyer',
        id: "rfxthreadlistbuyer",
        buttonDefinition: buttonDefinition,
        mainAction : {id:"new", link: "#/rfxthread/edit/buyer/0/" + $routeParams.id, icon:"mdi-plus"},
        excelExport: true,
        valuesInteger: [
            {
                name: "RFQHId",
                value: $routeParams.id
            }
        ]
    };
    this.getMeta = function () {
        return this.meta;
    }
}